const platform = require("../harbor-platform").platform;

const filter = platform.filter;

module.exports = filter.allowContribution.bind(filter);
